import React from "react"

const IconeChatGPT = ({
    size = {},
    renderText,
    ativo = true,
    ...rest
}) => {
    // const { size = {}, ...rest } = props

    return (
        <svg
            width={size.width || "100%"}
            height={size.height || "100%"}
            viewBox="0 0 1100.04136 484.1574"
            version="1.1"
            id="svg1"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <defs id="defs1" />
            <g id="layer1" transform="translate(-999.999999,-154.7717)">
                {/* Background */}
                <rect
                    fill={ativo ? "#10a37f" : "#868483"}
                    fillOpacity={1}
                    fillRule="evenodd"
                    strokeWidth={1.00157}
                    strokeDasharray="none"
                    id="rect1"
                    width="484.04138"
                    height="484.15741"
                    x="319.23917"
                    y="154.7717"
                    rx="61.246277"
                    ry="59.222702"
                />
                {/* Logotipo */}
                <path
                    d="m 744.56837,358.01757 a 106.61242,106.61242 0 0 0 -9.16336,-87.57235 107.82898,107.82898 0 0 0 -116.14102,-51.73832 106.61292,106.61292 0 0 0 -80.4166,-35.85057 107.83886,107.83886 0 0 0 -102.86905,74.66271 106.64923,106.64923 0 0 0 -71.29614,51.72133 107.8461,107.8461 0 0 0 13.2636,126.44281 106.61695,106.61695 0 0 0 9.16299,87.57265 107.83981,107.83981 0 0 0 116.1414,51.73782 106.61129,106.61129 0 0 0 80.41641,35.85083 107.83981,107.83981 0 0 0 102.90346,-74.70481 106.6469,106.6469 0 0 0 71.29602,-51.72177 107.8471,107.8471 0 0 0 -13.29771,-126.40033 z M 583.70101,582.86551 a 79.972402,79.972402 0 0 1 -51.342,-18.56203 c 0.64949,-0.35416 1.78904,-0.97899 2.53159,-1.43376 l 85.21755,-49.22446 a 13.855969,13.855969 0 0 0 7.00304,-12.12412 V 381.38062 l 36.02001,20.79829 a 1.2792293,1.2792293 0 0 1 0.69976,0.98654 v 99.4943 a 80.30731,80.30731 0 0 1 -80.12995,80.20576 z M 411.37488,509.26686 a 79.938364,79.938364 0 0 1 -9.56804,-53.74726 c 0.63275,0.37983 1.73802,1.05499 2.53121,1.51077 l 85.21724,49.22371 a 13.866916,13.866916 0 0 0 13.99854,0 l 104.042,-60.07439 v 41.5966 a 1.2916239,1.2916239 0 0 1 -0.51466,1.10532 l -86.14601,49.73806 A 80.291266,80.291266 0 0 1 411.3752,509.26686 Z M 388.95666,323.22929 a 79.913827,79.913827 0 0 1 41.74829,-35.16711 c 0,0.73405 -0.0422,2.03405 -0.0422,2.93602 v 98.44794 a 13.84414,13.84414 0 0 0 6.99468,12.11644 l 104.04145,60.06658 -36.01881,20.79723 a 1.2928823,1.2928823 0 0 1 -1.2155,0.11023 L 418.31042,432.75571 A 80.290888,80.290888 0 0 1 388.95666,323.22929 Z m 295.93458,68.8661 -104.04282,-60.07407 36.02,-20.78975 a 1.2869681,1.2869681 0 0 1 1.2143,-0.10916 l 86.15482,49.73813 A 80.222183,80.222183 0 0 1 691.84288,505.60433 V 404.21189 a 13.839296,13.839296 0 0 0 -6.95164,-12.1165 z m 35.84969,-53.95696 c -0.63238,-0.38845 -1.73764,-1.05506 -2.53046,-1.51001 l -85.21868,-49.22423 a 13.885791,13.885791 0 0 0 -13.99746,0 l -104.04176,60.07515 v -41.5966 a 1.2916239,1.2916239 0 0 1 0.51466,-1.10526 l 86.14633,-49.69691 a 80.214381,80.214381 0 0 1 119.12712,83.05786 z m -225.3711,74.13999 -36.02844,-20.79824 a 1.2785372,1.2785372 0 0 1 -0.69977,-0.98779 V 290.9982 a 80.21457,80.21457 0 0 1 131.53916,-61.59269 c -0.64943,0.35441 -1.78056,0.97886 -2.53153,1.4345 l -85.21755,49.22378 a 13.843322,13.843322 0 0 0 -7.00304,12.11568 z m 19.56563,-42.1872 46.33896,-26.7634 46.33765,26.74604 v 53.50974 l -46.33765,26.74767 -46.33878,-26.74741 z"
                    fill="#ffffff"
                    fillOpacity={1}
                    strokeWidth={0.62917}
                />
                {/* Texto ChatGPT */}
                {/* {renderText
                    ? (
                        <text
                            x="1800px"
                            y="89%"
                            fontFamily="Arial, sans-serif"
                            fontSize="300px"
                            fontWeight="bold"
                            fill={ativo ? "#000000" : "#b3b3b3"}
                            textAnchor="middle"
                            dy=".3em"
                        >
                    Assistente IA
                        </text>
                    )
                    : null} */}
            </g>
        </svg>
    )
}

export default IconeChatGPT
